/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {Address} from './Address';

/**
 * The CreateAddressResponse model module.
 * @module model/CreateAddressResponse
 * @version v1
 */
export class CreateAddressResponse {
  /**
   * Constructs a new <code>CreateAddressResponse</code>.
   * @alias module:model/CreateAddressResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>CreateAddressResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CreateAddressResponse} obj Optional instance to populate.
   * @return {module:model/CreateAddressResponse} The populated <code>CreateAddressResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CreateAddressResponse();
      if (data.hasOwnProperty('status'))
        obj.status = ApiClient.convertToType(data['status'], 'String');
      if (data.hasOwnProperty('resource'))
        obj.resource = Address.constructFromObject(data['resource']);
      if (data.hasOwnProperty('message'))
        obj.message = ApiClient.convertToType(data['message'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} status
 */
CreateAddressResponse.prototype.status = undefined;

/**
 * @member {module:model/Address} resource
 */
CreateAddressResponse.prototype.resource = undefined;

/**
 * @member {String} message
 */
CreateAddressResponse.prototype.message = undefined;

